import server from './http';

//获取推荐列表
const PcRecommend = (params) => server.newshttp.get('v2/api/ExternNews/Recommend', params);
//获取资讯列表
const ReadExternNewsList = (params) => server.newshttp.get('v2/api/ExternNews/List', params);
//获取用户交易历史合约列表
const His = (params) => server.newshttp.get('v2/api/Symbol/His', params);
//获取7*24资讯 (快讯)
const ReadExternNewsLetterList = (params) => server.newshttp.post('v2/api/ExternNews/ReadExternNewsLetterList', params);
//获取财经数据
const GetEconomicData = (params) => server.newshttp.post('v2/api/Economic/GetEconomicData', params);
//获取财经假期
const GetEconomicHolidays = (params) => server.newshttp.post('v2/api/Economic/GetEconomicHolidays', params);
//获取国家号码前缀
const GetCountrys = (params) => server.http.get('v2/api/Common/GetCountrys', params);
//v2:注册-海外的落地推广页
const RegisterOverseas = (params) => server.http.post('v2/api/Register/RegisterOverseas', params);
//获取验证码-手机
const GetByMobile = (params) => server.http.post('v2/api/VerifyCode/GetByMobile', params);
// 获取手机验证码
const ReadExternNews = (params) => server.newshttp.post('v2/api/ExternNews/ReadExternNews', params);
//新增广告投放点击记录
const AddClickLog = (params) => server.activityhttp.get('v2/api/Advertising/AddClickLog', params);
//获取当前ip信息
const GetIp = (params = {}) => server.http.get('v2/api/Common/GetIp', params);
//获取切换实盘、模拟盘信息
const SwitchQuoteInfo = (params = {}) => server.http.get('v2/api/Quote/SwitchQuoteInfo', params);

/** 用户站点的接口 begin */
// 账号密码登录
const Login = (params) => server.http.post('v2/api/Login/Login', params);
// 一键登录注册
const LoginV2 = (params) => server.http.post('v2/api/Login/OneKeyLoginVcode', params);
// 重置登录密码
const ResetPassword = (params) => server.http.post('v2/api/User/ResetPassword', params, true);
// 获取用户状态
const UserStatus = (params = {}) => server.http.get('v2/api/User/UserStatus', params);
// 获取用户状态信息
const AccountStatus = (params = {}) => server.http.get('v2/api/User/AccountStatus', params);
// 发送验证码
const GetVerifycode = (params) => server.http.post('v2/api/User/GetVerifycode', params);
// 获取用户个人资料
const PersonalData = (params = {}) => server.http.get('v2/api/PersonalData/PersonalData', params);
// 个人资料新增编辑
const PersonalDataEditor = (params = {}) => server.http.post('v2/api/PersonalData/PersonalData', params);
// 校验验证码
const CheckVerifyCode = (params) => server.http.post('v2/api/User/CheckVerifyCode', params);
// 绑定邮箱
const SetEmail = (params) => server.http.post('v2/api/User/SetEmail', params);
// 解绑邮箱
const UnbindEmail = (params = {}) => server.http.get('v2/api/User/UnbindEmail', params);
// 获取用户基本信息
const UserInformation = (params = {}) => server.http.get('v2/api/User/UserInformation', params);
// 获取用户基本信息
const ModifyPassword = (params = {}) => server.http.post('v2/api/User/ModifyPassword', params, true);
// 设置、重置 用户交易密码
const TradePasswordSet = (params = {}) => server.http.post('v2/api/TradePassword/Set', params);
// 获取用户绑卡信息
const GetWalletBank = (params = {}) => server.http.post('v2/api/WalletBank/GetWalletBank', params, true);
// 获取资金流水筛选信息
const GetFlowFiltering = (params = {}) => server.http.get('v2/api/Flow/GetFlowFiltering', params);
// 获取资金流水
const GetFlowLogRevision = (params = {}) => server.http.post('v2/api/Flow/GetFlowLogRevision', params);
// 获取资金流水-返佣
const GetCommissionFlowLog = (params = {}) => server.http.post('v2/api/Flow/GetCommissionFlowLog', params);
// 获取资金流水筛选条件
const GetFlowFilteringRevision = (params = {}) => server.http.get('v2/api/Flow/GetFlowFilteringRevision', params);
// 获取入金范围
const GetRechargeRange = (params = {}) => server.http.get('v2/api/Wallet/GetRechargeRange', params);
// 绑定银行卡
const AddBankNoCaptcha = (params = {}) => server.http.post('v2/api/WalletBank/AddBankNoCaptcha', params, true);
// 解绑银行卡
const Unbindbank = (params = {}) => server.http.post('v2/api/WalletBank/Unbindbank', params, true);
// 设置用户密码
const SetPassword = (params = {}) => server.http.post('v2/api/User/SetPassword', params, true);
const VaildPwd = (params = {}) => server.http.post('v2/api/TradePassword/VaildPwd', params);
// 设用户头像
const SetHeadpic = (params = {}) => server.http.post('v2/api/User/SetHeadpic', params);
// 设置用户昵称
const AlterNickName = (params = {}) => server.http.post('v2/api/User/AlterNickName', params);
// 设置邀请码
const SetProxy = (params = {}) => server.http.post('v2/api/User/SetProxy', params);
// 检查是否需要行为校验
const NeedCaptcha = (params = {}) => server.http.post('v2/api/User/NeedCaptcha', params);
// 检验是否注册
const CheckIsRegister = (params = {}) => server.http.post('v2/api/User/CheckIsRegister', params);
// 用户是否持仓
const JudgeHavePos = (params = {}) => server.http.get('v2/api/Wallet/JudgeHavePos', params);
// 根据transid获取该笔交易的交易返佣信息
const GetTradeComissionByTransId = (params = {}) => server.http.get('v2/api/TradeCoomission/GetTradeComissionByTransId', params);
// 实名认证-设置基本信息
const SetBasicInfoOverSeasNew = (params = {}) => server.http.post('v2/api/Account/SetBasicInfoOverSeasNew', params);
// 历史报表——资金流水
const GetFundFlow = (params = {}) => server.http.post('v2/api/Flow/GetFundFlow', params);

// 获取邮箱验证码
const GetByEmail = (params = {}) => server.http.post('v2/api/VerifyCode/GetByEmail', params);
// 上传身份证明文件
const SetIdPhotoAndAddressPic = (params = {}) => server.http.post('v2/api/Account/SetIdPhotoAndAddressPic', params);
// 协议认证勾选提交
const ProtocolVerification = (params = {}) => server.http.post('v2/api/Account/ProtocolVerification', params);
// 用户上传手持证件-无需再走签名流程
const SetHoldPhoto = (params = {}) => server.http.post('v2/api/Account/SetHoldPhoto', params);
// 重置MT５实盘密码
const ResetMt5AccountPwd = (params = {}) => server.http.post('v2/api/User/ResetMt5AccountPwd', params);
// 重置MT4实盘密码
const ResetMt4AccountPwd = (params = {}) => server.http.post('v2/api/User/ResetMt4AccountPwd', params);
// 添加银行卡
const AddBankWire = (params = {}) => server.http.post('v2/api/WalletBank/AddBankWire', params,true);
// 获取币种
const BankCardCurrency = (params = {}) => server.http.get('v2/api/WalletBank/BankCardCurrency', params);
const GetBasicInfoOverSeas = (params = {}) => server.http.get('v2/api/Account/GetBasicInfoOverSeas', params);

// restFul 提币地址
/**
 *
 * @param {methods}
 * get 获取提币地址列表
 * delete 删除提币地址
 * patch 编辑提币地址
 * post 新增提币地址
 */
const WalletAddress = (params = {}, methods = 'get') => server.http[methods]('v2/api/WalletAddress/WalletAddress', params);
// // 获取提币地址
// const WalletAddress = (params = {}) => server.http.get('v2/api/WalletAddress/WalletAddress', params);
// 获取提币币种类型
const CurrencyType = (params = {}) => server.http.get('v2/api/WalletAddress/CurrencyType', params);
/** 用户站点的接口 end */

/** 资讯站点的接口 begin */


// 获取行情、专题分析列表 3:专题分析 2:行情分析
const RecommendList = (params = {}) => server.newshttp.get('v2/api/ExternNews/List', params);
// 获取财经数据国家和星级
const GetCountryWithStar = (params = {}) => server.newshttp.get('v2/api/Economic/GetCountryWithStar', params);
// 获取财经事件
const GetEconomicEvents = (params = {}) => server.newshttp.post('v2/api/Economic/GetEconomicEvents', params);
// 获取7x24小时快讯详情
const ReadLetterNews = (params = {}) => server.newshttp.get('v2/api/ExternNews/ReadLetterNews', params);
// 获取专题分类
const TopicCategory = (params = {}) => server.newshttp.get('v2/api/ExternNews/TopicCategory', params);
// 交易品种多空预测
const Trends = (params = {}) => server.newshttp.get('v2/api/Symbol/Trends', params);
// 交易品种指标分析
const Analysis = (params = {}) => server.newshttp.get('v2/api/Symbol/Analysis', params);
// App 首页、新闻资讯Banner
const Banner = (params = {}) => server.newshttp.get('v2/api/App/Banner', params);
// 获取官网首页品种
const GetPcContractType = (params = {}) => server.newshttp.get('v2/api/Quote/GetPcContractType', params);
// APP基础信息接口
const AppInfo = (params = {}) => server.newshttp.get('v2/api/App/AppInfo', params);

/** 资讯站点的接口 end */

/** 活动站点的接口 begin */

// 获取新户活动(注册送股活动)
const GetOpenAccountActivity = (params = {}) => server.activityhttp.get('v2/api/Activity/GetOpenAccountActivity', params);

/** 活动站点的接口 end */

/** 行情站点的接口 begin */

// 获取WsUrl
const wssUrl = (params = {}) => server.hqhttp.get('v1/api/quote/wssUrl', params, true);
// 获取K线行情
const candleLines = (params = {}) => server.hqhttp.get('v2/api/quote/candleLines', params);
// v2行情：e锤-首页默认品种
const getETradeDefaultSymbol = (params = {}) => server.hqhttp.get('v2/api/contract/getETradeDefaultSymbol', params);

// 商品列表 Rest Api 合约id获取涨跌
const product = (params = {}) => server.hqhttp.get('v2/api/quote/product', params);
// 自选合约列表
const watchList = (params = {}) => server.hqhttp.get('v2/api/contract/eTradeWatchList', params);
// 合约分类
const contractType = (params = {}) => server.hqhttp.get('v2/api/contract/contractType', params);
// 自选合约列表-添加
const addWatchList = (params = {}) => server.hqhttp.post('v2/api/contract/addWatchList', params, true);
// 自选合约列表-删除
const removeWatchList = (params = {}) => server.hqhttp.post('v2/api/contract/removeWatchList', params, true);
// 获取多个品种的行情信息
const contractMktDataInfo = (params = {}) => server.hqhttp.get('v2/api/quote/contractMktDataInfo', params, true);

/** 行情站点的接口 end */

/** 支付站点的接口 begin */

// 获取入金通道大分类
const GetPayType = (params = {}) => server.payhttp.get('v2/api/Deposit/GetPayType', params);
// Fairpay国家接口
const FairPayCountry = (params = {}) => server.payhttp.get('v2/api/Deposit/FairPayCountry', params);
// Fairpay币种可用银行接口
const FairPayMethod = (params = {}) => server.payhttp.get('v2/api/Deposit/FairPayMethod', params);
// 根据通道分类获取通道列表
const PayInChannel = (params = {}) => server.payhttp.get('v2/api/Deposit/PayInChannel', params);
// 根据支付通道payid获取对应入金页面需要的数据
const PayInChannelPage = (params = {}) => server.payhttp.get('v2/api/Deposit/PayInChannelPage', params);
// 获取USDT入金未完成订单
const OTCPayingOrder = (params = {}) => server.payhttp.get('v2/api/Deposit/OTCPayingOrder', params);
// 获取出金通道大分类
const GetWithdrawType = (params = {}) => server.payhttp.get('v2/api/Withdraw/GetPayType', params);
// 下单接口
const payment = (payurl = '', params = {}) => server.paymenthttp.get(payurl, params);
// 链上入金
const blockchain = (params = {}) => server.payhttp.get('v2/api/Deposit/blockchain', params);
// 电汇入金
const filedata = (params = {}) => server.payhttp.post('v2/api/Deposit/telegraphictransferpaid/filedata', params);
// 获取电汇入金信息
const TelegraphicTransferInfo = (params = {}) => server.payhttp.get('v2/api/Deposit/TelegraphicTransferInfo', params);
// 最近的一笔电汇入金订单记录
const RecentlyWireInOrder = (params = {}) => server.payhttp.get('v2/api/Deposit/RecentlyWireInOrder', params);
// 最近的一笔链上入金订单记录
const RecentlyChainInOrder = (params = {}) => server.payhttp.get('v2/api/Deposit/RecentlyChainInOrder', params);
// 最近的一笔扫码入金订单记录
const RecentlyQRCodeInOrder = (params = {}) => server.payhttp.get('v2/api/Deposit/RecentlyQRCodeInOrder', params);
// USDT入金确认订单
const OTCOrderConfirm = (params = {}) => server.payhttp.post('v2/api/Deposit/OTCOrderConfirm', params, true);
// USDT入金取消订单
const OTCOrderCancel = (params = {}) => server.payhttp.post('v2/api/Deposit/OTCOrderCancel', params, true);
// Paylinx 获取扫码订单信息
const GetQRCodeInfo = (params = {}) => server.payhttp.get('v2/api/Deposit/GetQRCodeInfo', params);
// 获取汇率
const GetExchangeRate = (params = {}) => server.payhttp.get('v2/api/ExchangeRate/GetExchangeRate', params);
// 获取出金通道列表
const PayOutChannel = (params = {}) => server.payhttp.get('v2/api/Withdraw/PayOutChannel', params);
// 获取出金页面详情
const PayOutChannelPage = (params = {}) => server.payhttp.get('v2/api/Withdraw/PayOutChannelPage', params);
// 最近的一笔常规出金订单记录
const RecentlyRoutineOutOrder = (params = {}) => server.payhttp.get('v2/api/Withdraw/RecentlyRoutineOutOrder', params);
// 最近的一笔链上出金订单记录
const RecentlyChainOutOrder = (params = {}) => server.payhttp.get('v2/api/Withdraw/RecentlyChainOutOrder', params);
// 常规出金
const walletrquest = (params = {}) => server.payhttp.post('v2/api/Withdraw/walletrquest', params, true);
// 链上出金
const walletRquestChain = (params = {}) => server.payhttp.post('v2/api/Withdraw/walletRquestChain', params, true);
// 获取银行类型
const CurrencyBank = (params = {}) => server.payhttp.get('v2/api/Bank/CurrencyBank', params);
// 获取币种分类列表
const GetPayCurrencyCategoryList = (params = {}) => server.payhttp.get('v2/api/Bank/GetPayCurrencyCategoryList', params);
// 获取网银出金银行卡信息
const LatestOnlineBankInfo = (params = {}) => server.payhttp.get('v2/api/Withdraw/LatestOnlineBankInfo', params);
// 网银出金可用银行
const OnlineBankInfoForApp = (params = {}) => server.payhttp.get('v2/api/Withdraw/OnlineBankInfoForApp', params);
// app网银出金
const OnlineBankPayoutForApp = (params = {}) => server.payhttp.post('v2/api/Withdraw/OnlineBankPayoutForApp', params,true);
// 电汇出金
const wireWalletRquest = (params = {}) => server.payhttp.post('v2/api/Withdraw/wireWalletRquest', params,true);
// 撤销出金订单
const CancelWithdrawOrder = (params = {}) => server.payhttp.post('v2/api/Withdraw/CancelWithdrawOrder', params,true);
// 获取资金转移配置项
const Config = (params = {}) => server.payhttp.get('v2/api/Transfer/Config', params);
// 获取资金转移配置项
const Apply = (params = {}) => server.payhttp.post('v2/api/Transfer/Apply', params);

/** 支付站点的接口 end */

/** 交易站点的接口 begin */
// 查询持仓 - 已持仓
const queryPosition = (params = {}) => server.tradehttp.get('v2/api/Position/queryPosistionByPage', params);
// 获取用户余额
const getUserBalance = (params = {}) => server.tradehttp.post('v2/api/Common/getUserBalance', params, true);
// 查询委托订单
const queryOrder = (params = {}) => server.tradehttp.get('v2/api/Order/queryOrder', params);
// 查询历史交易 - 已平仓
const closeTrade = (params = {}) => server.tradehttp.get('v2/api/Trade/closeTrade', params);
// 查询已撤单的委托订单- 已撤单
const queryCancelledOrder = (params = {}) => server.tradehttp.get('v2/api/Order/queryCancelledOrder', params);
// 买入界面
const buyPage = (params = {}) => server.tradehttp.get('v2/api/Order/buyPage', params);
// 获取已平仓订单的汇总信息
const closeTradeStats = (params = {}) => server.tradehttp.get('v2/api/Trade/closeTradeStats', params);
// 设置止盈止损界面显示数据
const showSetsltp = (params = {}) => server.tradehttp.post('v2/api/Trade/showSetsltp', params, true);
// 设置止盈止损
const setStopPrice = (params = {}) => server.tradehttp.post('v2/api/Trade/setStopPrice', params, true);
// 一键反手
const oneClickReversePos = (params = {}) => server.tradehttp.post('v2/api/Position/oneClickReversePos', params, true);
// 平仓
const closePos = (params = {}) => server.tradehttp.post('v2/api/Position/closePos', params, true);
// 平仓所有持仓
const closeAllPos = (params = {}) => server.tradehttp.post('v2/api/Position/closeAllPos', params, true);
// 撤单
const cancel = (params = {}) => server.tradehttp.post('v2/api/Order/cancel', params, true);
// 下单
const simplifyOrder = (params = {}) => server.tradehttp.post('v2/api/Order/simplifyOrder', params, true);
// 获取交易规则页
const tradeRule = (params = {}) => server.tradehttp.get('v2/api/Trade/tradeRule', params);
// 挂单修改
const modifyPendingOrder = (params = {}) => server.tradehttp.post('v2/api/Order/modifyPendingOrder', params, true);
/** 交易站点的接口 end */

/** 模拟交易站点的接口 begin */
const queryPositionDemo = (params = {}) => server.stradehttp.get('v2/api/Position/queryPosistionByPage', params);
// 查询委托订单
const queryOrderDemo = (params = {}) => server.stradehttp.get('v2/api/Order/queryOrder', params);
// 获取已平仓订单的汇总信息
const closeTradeStatsDemo = (params = {}) => server.stradehttp.get('v2/api/Trade/closeTradeStats', params);
// 查询已撤单的委托订单- 已撤单
const queryCancelledOrderDemo = (params = {}) => server.stradehttp.get('v2/api/Order/queryCancelledOrder', params);
// 查询历史交易 - 已平仓
const closeTradeDemo = (params = {}) => server.stradehttp.get('v2/api/Trade/closeTrade', params);
// 买入界面
const buyPageDemo = (params = {}) => server.stradehttp.get('v2/api/Order/buyPage', params);
// 挂单修改
const modifyPendingOrderDemo = (params = {}) => server.stradehttp.post('v2/api/Order/modifyPendingOrder', params, true);
// 撤单
const cancelDemo = (params = {}) => server.stradehttp.post('v2/api/Order/cancel', params, true);
// 平仓
const closePosDemo = (params = {}) => server.stradehttp.post('v2/api/Position/closePos', params, true);
// 平仓所有持仓
const closeAllPosDemo = (params = {}) => server.stradehttp.post('v2/api/Position/closeAllPos', params, true);
// 一键反手
const oneClickReversePosDemo = (params = {}) => server.stradehttp.post('v2/api/Position/oneClickReversePos', params, true);
// 设置止盈止损
const setStopPriceDemo = (params = {}) => server.stradehttp.post('v2/api/Trade/setStopPrice', params, true);
// 获取用户余额
const getUserBalanceDemo = (params = {}) => server.stradehttp.post('v2/api/Common/getUserBalance', params, true);
// 下单
const simplifyOrderDemo = (params = {}) => server.stradehttp.post('v2/api/Order/simplifyOrder', params, true);
/** 模拟交易站点的接口 end */

/** */
export default {
  simplifyOrderDemo,
  getUserBalanceDemo,
  setStopPriceDemo,
  oneClickReversePosDemo,
  closeAllPosDemo,
  closePosDemo,
  cancelDemo,
  modifyPendingOrderDemo,
  buyPageDemo,
  closeTradeDemo,
  queryCancelledOrderDemo,
  queryOrderDemo,
  closeTradeStatsDemo,
  Apply,
  Config,
  FairPayMethod,
  SetHoldPhoto,
  PcRecommend,
  ReadExternNewsList,
  ReadExternNewsLetterList,
  GetEconomicData,
  GetEconomicHolidays,
  GetCountrys,
  RegisterOverseas,
  GetByMobile,
  ReadExternNews,
  AddClickLog,
  GetIp,
  modifyPendingOrder,
  cancel,
  closeTradeStats,
  UserStatus,
  AccountStatus,
  Login,
  GetVerifycode,
  LoginV2,
  ResetPassword,
  PersonalData,
  CheckVerifyCode,
  SetEmail,
  UnbindEmail,
  UserInformation,
  PersonalDataEditor,
  ModifyPassword,
  TradePasswordSet,
  RecommendList,
  product,
  GetWalletBank,
  GetFlowLogRevision,
  GetCountryWithStar,
  GetEconomicEvents,
  contractType,
  watchList,
  addWatchList,
  removeWatchList,
  wssUrl,
  candleLines,
  queryOrder,
  buyPage,
  GetFlowFiltering,
  GetPayType,
  PayInChannel,
  PayInChannelPage,
  OTCPayingOrder,
  payment,
  OTCOrderConfirm,
  OTCOrderCancel,
  getUserBalance,
  GetWithdrawType,
  GetQRCodeInfo,
  RecentlyQRCodeInOrder,
  RecentlyChainInOrder,
  blockchain,
  TelegraphicTransferInfo,
  RecentlyWireInOrder,
  filedata,
  GetExchangeRate,
  GetRechargeRange,
  PayOutChannel,
  PayOutChannelPage,
  RecentlyRoutineOutOrder,
  RecentlyChainOutOrder,
  AddBankNoCaptcha,
  walletrquest,
  WalletAddress,
  walletRquestChain,
  SetPassword,
  ReadLetterNews,
  simplifyOrder,
  VaildPwd,
  CurrencyType,
  GetFlowFilteringRevision,
  showSetsltp,
  queryPosition,
  closeTrade,
  queryCancelledOrder,
  setStopPrice,
  oneClickReversePos,
  closePos,
  closeAllPos,
  Unbindbank,
  tradeRule,
  TopicCategory,
  Trends,
  Analysis,
  GetOpenAccountActivity,
  SetHeadpic,
  AlterNickName,
  getETradeDefaultSymbol,
  SetProxy,
  NeedCaptcha,
  CheckIsRegister,
  JudgeHavePos,
  GetByEmail,
  Banner,
  GetPcContractType,
  contractMktDataInfo,
  AppInfo,
  SetBasicInfoOverSeasNew,
  SetIdPhotoAndAddressPic,
  ProtocolVerification,
  ResetMt5AccountPwd,
  AddBankWire,
  BankCardCurrency,
  CurrencyBank,
  GetBasicInfoOverSeas,
  His,
  GetTradeComissionByTransId,
  FairPayCountry,
  LatestOnlineBankInfo,
  OnlineBankInfoForApp,
  OnlineBankPayoutForApp,
  wireWalletRquest,
  GetFundFlow,
  CancelWithdrawOrder,
  GetCommissionFlowLog,
  GetPayCurrencyCategoryList,
  ResetMt4AccountPwd,
  queryPositionDemo,
  SwitchQuoteInfo
};
